import React from 'react';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { LoadingSpinner } from '../LoadingSpinner';

interface ExtensionProps {
	piletApi: PiletApi;
}

const LazyProjectPage = React.lazy(() => import('./ProjectPage'));
export const AsyncProjectPage: React.FC<ExtensionProps> = props => (
	<React.Suspense fallback={<LoadingSpinner />}>
		<LazyProjectPage {...props} />
	</React.Suspense>
);

const LazyProjectsPage = React.lazy(() => import('./ProjectsPage'));
export const AsyncProjectsPage: React.FC<ExtensionProps> = props => (
	<React.Suspense fallback={<LoadingSpinner />}>
		<LazyProjectsPage {...props} />
	</React.Suspense>
);

const LazyRecentlyDeletedPage = React.lazy(() => import('./RecentlyDeletedPage'));
export const AsyncRecentlyDeletedPage: React.FC<ExtensionProps> = props => (
	<React.Suspense fallback={<LoadingSpinner />}>
		<LazyRecentlyDeletedPage {...props} />
	</React.Suspense>
);

const LazyProjectRestorePage = React.lazy(() => import('./ProjectRestorePage'));
export const AsyncProjectRestorePage: React.FC<ExtensionProps> = props => (
	<React.Suspense fallback={<LoadingSpinner />}>
		<LazyProjectRestorePage {...props} />
	</React.Suspense>
);

const LazyBlockDevelopmentPage = React.lazy(() => import('./BlockDevelopmentPage'));
export const AsyncBlockDevelopmentPage: React.FC<ExtensionProps> = props => (
	<React.Suspense fallback={<LoadingSpinner />}>
		<LazyBlockDevelopmentPage {...props} />
	</React.Suspense>
);
